import React from 'react';

const Communitycard = (props) => {
  return ( 
    <div className={props.cardstyle}>
      <div className='community_card_top'>
        <img src={props.cardimg} alt={props.cardname} />
        <div className='community_card_person'>
          <div className='community_card_name'>{props.cardname}</div>
          <div className='community_card_role'>{props.cardrole}</div>
        </div>
      </div>
      <div className='community_card_text'>{props.cardtext}</div>
      <div className='community_card_stars'>{props.cardstars}</div>
      <div className='community_card_tags'>
        <div className='community_card_tag'>{props.cardtag1}</div>
        <div className='community_card_tag'>{props.cardtag2}</div>
      </div>
    </div>
   );
}
 
export default Communitycard;
